import styled from 'styled-components';

import { PharmindexIntegrationInfo } from '@dreryk/medicine-database-pharmindex-api';

import { rowIndexKeyExtractor, Table } from '@dreryk/react-components';

import {
   usePharmindexIntegrationStatusTableColumns,
   usePharmindexIntegrationStatusTableDataConfiguration,
} from './PharmindexIntegrationStatusTable.hooks';

const StyledIntegrationStatusTable = styled.section`
   width: 100%;
`;
StyledIntegrationStatusTable.displayName = 'StyledIntegrationStatusTable';

export const PharmindexIntegrationStatusTable = (): JSX.Element => {
   const columns = usePharmindexIntegrationStatusTableColumns();
   const dataConfiguration = usePharmindexIntegrationStatusTableDataConfiguration();

   return (
      <StyledIntegrationStatusTable>
         <Table<PharmindexIntegrationInfo>
            columns={columns}
            dataConfiguration={dataConfiguration}
            keyExtractor={rowIndexKeyExtractor}
            testId={'pharmindexIntegrationStatus'}
         />
      </StyledIntegrationStatusTable>
   );
};
